//PAGE HEADER - H1
//*******************************************************************
import React from 'react'
import '../styles/pageHeaderStyles.css'

//*******************************************************************
//class component constructor
//export default class PageHeader extends React.Component {
//  render() {
//    return <h1>{this.props.title}</h1>;
//  }
//}
//*******************************************************************
export default function PageHeader(props) {
    return (
        
        <div class={props.divClass}>        
            <h1 id={props.id} class={props.elementClass}>{props.title}</h1>
        </div>
    
    );
}
//*******************************************************************
